// extracted by mini-css-extract-plugin
export default {"button":"buttonNoStyle_button__Jbyx2"};